export const getQuerySuggestSetInitialState = () => ({});
